// extracted by mini-css-extract-plugin
module.exports = {"FrameWrapper":"ServerConnectFrame_FrameWrapper__IXrWM","FullWidth":"ServerConnectFrame_FullWidth__duCjv"};